const yellow = "#F1BE17";
const blue = "#1E446B";
const white = "#FFFFFF";

document.addEventListener('DOMContentLoaded', function() {
  const soServices = document.querySelector("#so-services-details");

  if(soServices === null) {
    return;
  }

  const servicesConfig = {
    datacenter: {
      bullets: [
        "Hybride, private oder cloudbasierte Infrastruktur passend zu den Anforderungen Ihres Unternehmens",
        "Fokus auf Sicherheit, Verfügbarkeit und Skalierbarkeit",
        "Migration und Modernisierung bestehender Systeme sowie Aufbau neuer IT-Infrastruktur",
        "Stabile und zukunftsfähige Cloud-Architektur mit Backup, Monitoring und klaren Notfallkonzepten"
      ],
      result: "Eine belastbare Infrastruktur, die Ihre Anwendungen sicher und skalierbar trägt."
    },
    networktechnology: {
      bullets: [
        "Planung und Realisierung von LAN, WLAN und WAN für reibungslose Abläufe",
        "Performance und Redundanz als Grundlage für hohe Verfügbarkeit",
        "Zuverlässige Vernetzung von Arbeitsplätzen und Systemen über mehrere Standorte",
        "Sicherheitsanforderungen werden bei Entwurf der Netzwerkarchitektur direkt integriert"
      ],
      result: "Schnelle und sichere Vernetzung aller Standorte, Systeme und Nutzer."
    },
    security_and_entry_technology: {
      bullets: [
        "Standortüberwachung mit Kamera- und Videotechnik, damit kritische Bereiche jederzeit im Blick bleiben",
        "Zutrittssteuerung über klare Rollen- und Rechtekonzepte, sodass nur berechtigte Personen Zugang zu sensiblen Bereichen erhalten",
        "Sensoren zur Erkennung von Temperatur, Rauch, Gas oder Wasser, die Schäden zu verhindern helfen",
        "Zentrales Monitoring aller Systeme, damit bei Auffälligkeiten sofort reagiert werden kann"
      ],
      result: "Schutz für Daten, Anwendungen und Zugänge – auditierbar und rechtskonform."
    },
    smart_building: {
      bullets: [
        "Automatische Steuerung von Heizung, Licht und Klimatisierung für effiziente Nutzung und geringeren Energieverbrauch",
        "Vernetzung von Sensorik und Gebäudetechnik zur Erfassung von Temperatur, Luftqualität und Anwesenheit",
        "Bedarfsgerechte Automatisierung von Beleuchtung, Beschattung und Lüftung für mehr Komfort im Arbeitsalltag",
        "Zentrale Steuerung und Transparenz über Verbräuche zur Optimierung von Betriebskosten und Nachhaltigkeit"
      ],
      result: "Ein Gebäude, das Ressourcen intelligent nutzt und den Arbeitsalltag spürbar verbessert."
    }
  };

  const availableServices = Object.keys(servicesConfig).filter((service) => document.getElementById(`${service}_span`) !== null);

  if(availableServices.length === 0) {
    return;
  }

  let currentElement = null;

  availableServices.forEach((service) => {
    const icon = document.getElementById(`service-card-${service}-icon`);
    const headline = document.getElementById(`service-card-${service}-headline`);
    const span = document.getElementById(`${service}_span`);

    if(span) {
      span.addEventListener("click", function () {
        appendCurrentElement(service, icon, headline);
      });
    }
  });

  appendCurrentElement(availableServices[0], document.getElementById(`service-card-${availableServices[0]}-icon`), document.getElementById(`service-card-${availableServices[0]}-headline`));

  function appendCurrentElement(itemToBeAppended, iconToBeAppended, headlineToBeAppended) {
    if(!servicesConfig[itemToBeAppended]) {
      return;
    }

    if(currentElement) {
      removeCurrentElement(currentElement);
    }

    currentElement = itemToBeAppended;
    document.getElementById("icon-placeholder").innerHTML = iconToBeAppended ? iconToBeAppended.innerHTML : "";
    document.getElementById("headline-placeholder").innerHTML = headlineToBeAppended ? headlineToBeAppended.innerHTML : "";

    servicesConfig[itemToBeAppended].bullets.forEach((bulletText, index) => {
      const bulletElement = document.getElementById(`bulletpoint_0${index + 1}`);
      if(bulletElement) {
        bulletElement.innerText = bulletText;
      }
    });
    document.getElementById("result").innerText = servicesConfig[itemToBeAppended].result;

    const lineElement = document.getElementById(`${itemToBeAppended}_line`);
    const spanElement = document.getElementById(`${itemToBeAppended}_span`);
    if(lineElement) {
      lineElement.style.backgroundColor = yellow;
    }
    if(spanElement) {
      spanElement.style.color = yellow;
    }
  }

  function removeCurrentElement(elementToBeRemoved) {
    if(!elementToBeRemoved) {
      return;
    }

    const lineElement = soServices.querySelector(`#${elementToBeRemoved}_line`);
    const spanElement = soServices.querySelector(`#${elementToBeRemoved}_span`);

    if(lineElement) {
      lineElement.style.backgroundColor = blue;
    }
    if(spanElement) {
      spanElement.style.color = white;
    }
  }
});
